import { useEffect, useState } from 'react';
import ContainerWithGoBack from '../../../UI/ContainerWithGoBack';
import { findAlunosSemResponsavelFinanceiro } from '../../../AlunoTurma/api-aluno-turma';
import { CircularProgress, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useLocation } from 'react-router';

const useStyles = makeStyles({
    title: {
        marginTop: '20px',
        marginBottom: '20px'
    },
    adicionarDisciplina: {
        paddingBottom: '10px',
    },
    formControl: {
        marginBottom: '10px'
    }
});


const AlunoSemResponsavelFinanceiro = () => {
    const location = useLocation();
    const anoLetivo = location.state.anoLetivo;
    const [alunosTurmas, setAlunosTurmas] = useState([]);
    const [isLoading, setIsloading] = useState(true);
    const classes = useStyles();

    useEffect(() => {
        setIsloading(true);
        findAlunosSemResponsavelFinanceiro(anoLetivo).then((data) => {
            if (data.error) {
                console.log(data);
            } else {
                setAlunosTurmas(data);
            }
            setIsloading(false);
        })
    }, [anoLetivo]);


    return (
        <ContainerWithGoBack>
            <Typography className={classes.title} variant="h5">
                Relatório Alunos Sem Responsável Financeiro
            </Typography>


            {isLoading ?
                <div className={classes.loading}>
                    <CircularProgress color="primary" />
                    Carregando...
                </div> :
                <>
                    <Table size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Ano Letivo</TableCell>
                                <TableCell>Turma</TableCell>
                                <TableCell>Aluno</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {alunosTurmas.map((at) => (
                                <TableRow key={at.codigo}>
                                    <TableCell>{at.turma.anoLetivo}</TableCell>
                                    <TableCell>{at.turma.descricao}</TableCell>
                                    <TableCell>{at.aluno.nome}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    <Typography className={classes.title} variant="h5">
                        Total: {alunosTurmas.length} alunos
                    </Typography>

                </>
            }


        </ContainerWithGoBack>
    );
}

export default AlunoSemResponsavelFinanceiro;